/* istanbul ignore file */
import LinearProgress from '@mui/material/LinearProgress';
// components
import FilePreviewLayout from './FilePreviewLayout';

type LoadingFilePreviewLayoutProps = {
  loadingArtifactObject: any;
  onRemove: () => void;
};

const LoadingFilePreviewLayout = ({ loadingArtifactObject, onRemove }: LoadingFilePreviewLayoutProps) => {
  return (
    <FilePreviewLayout artifactObject={loadingArtifactObject} onRemove={onRemove}>
      {loadingArtifactObject && loadingArtifactObject.loadingProgress ? (
        <LinearProgress
          color="primary"
          variant="determinate"
          value={Number(loadingArtifactObject.loadingProgress)}
          className="progress progress-xs"
          sx={{ marginTop: '-5px' }}
        />
      ) : null}
    </FilePreviewLayout>
  );
};

export default LoadingFilePreviewLayout;
